const m = require("./eh-tetris_konami.js");

/*
 * This helps us customise the modal
 */
m.HT.customise_div = function(d) {
  d.outerHTML =
`<div class="tetris-modal modal is-active">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title"><i class="ph-bold ph-joystick"></i> Enjoy!</p>
      <button class="delete" aria-label="close"></button>
    </header>
    <section class="modal-card-body">
      <div id="tetris-div-container">
        <div id="tetris-div">
        </div>
      </div>
    </section>
    <footer class="modal-card-foot">
      <p>Do say thanks if you are enjoying this easter egg!</p>
    </footer>
  </div>
</div>`;

  function closeModal($el) {
    $el.classList.remove('is-active');
    if ($el.classList.contains("tetris-modal")) {
      m.konami.action = m.konami.orig_action;
      $el.remove();
    }
  }

  function closeAllModals() {
    (document.querySelectorAll('.modal') || []).forEach(($modal) => {
      closeModal($modal);
    });
  }

  // Add a click event on various child elements to close the parent modal
  (document.querySelectorAll('.tetris-modal .modal-background, .tetris-modal .modal-close, .tetris-modal .modal-card-head .delete, .tetris-modal .modal-card-foot .button') || []).forEach(($close) => {
    const $target = $close.closest('.modal');

    $close.addEventListener('click', () => {
      closeModal($target);
    });
  });

  // Add a keyboard event to close all modals
  document.addEventListener('keydown', (event) => {
    if(event.key === "Escape") {
      closeAllModals();
    }
  });
};
